"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("./index.scss"));

var _button = _interopRequireDefault(require("../form/button"));

var _classnames = _interopRequireDefault(require("classnames"));

var _heading = _interopRequireDefault(require("../heading"));

// Hero Header
// ===========
var HeroHeader = function HeroHeader(props) {
  return _react["default"].createElement("header", {
    className: (0, _classnames["default"])(_index["default"].HeroHeader, props.className),
    style: {
      backgroundImage: "url(".concat(props.image, ")")
    }
  }, props.headingText && _react["default"].createElement(_heading["default"], {
    type: "large",
    className: _index["default"].mainHeading
  }, props.headingText), props.children, _react["default"].createElement(_button["default"], {
    type: "secondary-light",
    onClick: props.callback,
    className: _index["default"].Button
  }, props.buttonText));
};

HeroHeader.propTypes = {
  headingText: _propTypes["default"].string,
  buttonText: _propTypes["default"].string.isRequired,
  image: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  callback: _propTypes["default"].func,
  children: _propTypes["default"].node
};
var _default = HeroHeader;
exports["default"] = _default;